import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { createBrowserHistory } from "history";
import { createReduxHistoryContext } from "redux-first-history";
import apiMiddleware from "../middleware/api";
import actionArrayMiddleware from "../middleware/actionArray";

// import createLogger from "redux-logger";
import createReducers from "../reducers";

/**
 * Creates the Redux store and the Redux-synced history used by the router.
 * Returns { store, history }.
 */
export default function configureStore(baseHistory = createBrowserHistory()) {
	const { createReduxHistory, routerMiddleware, routerReducer } =
		createReduxHistoryContext({ history: baseHistory });

	const store = createStore(
		createReducers(routerReducer),
		composeWithDevTools(
			applyMiddleware(
				routerMiddleware,
				actionArrayMiddleware,
				// Navigating on the base history is picked up by the Redux history listener
				apiMiddleware(baseHistory)
			)
		)
	);

	return { store, history: createReduxHistory(store) };
}
